import * as yup from "yup";

export const schema = (messages: any) => yup.object().shape({
    name: yup.string().required(messages['productAttributes.productAttributesInfo.edit.nameRequired'].toString()),
});
